import { createSelector } from "@reduxjs/toolkit";

import { EducatorOnboardingStateType } from "../../../utils";
import { StateType } from "../../../utils";

const selectOnboardingState = (state: StateType): EducatorOnboardingStateType =>
  state.educatorOnboardingReducer;

export const selectOnboardings = createSelector(
  selectOnboardingState,
  (state: EducatorOnboardingStateType) => state.onboardings
);

export const selectOnboarding = createSelector(
  selectOnboardingState,
  (state: EducatorOnboardingStateType) => state.onboarding
);

export const selectOnboardingsLoading = createSelector(
  selectOnboardingState,
  (state: EducatorOnboardingStateType) => state.loading
);

export const selectOnboardingsLoaded = createSelector(
  selectOnboardingState,
  (state: EducatorOnboardingStateType) => state.loaded
);
